/* eslint-disable no-bitwise */

import { UntypedFormGroup } from "@angular/forms";
import { Cellstyle } from "~app/common/components/hot-doc/hotdoc/cell";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ProduktmatrisGrid } from "../../produktinstruktioner-details/matris/ProduktmatrisGrid";
import { BegransningCell } from "../../produktinstruktioner-details/matris/cells/begransningCell";
import { EmptyCell } from "../../produktinstruktioner-details/matris/cells/emptyCell";
import { ProduktdefinitionHeaderData } from "../ProduktdefinitionHeaderData";
import { LangdDiameterMatris } from "./LangdDiameterMatris";

export class Begransningsmatris extends LangdDiameterMatris {

    constructor(grid: ProduktmatrisGrid,
        form: UntypedFormGroup,
        headerData: ProduktdefinitionHeaderData,
        canEdit: boolean) {
        super(grid, form, headerData, canEdit);
    }

    getBegransningsmatris(raskModalService: RaskModalService, form: UntypedFormGroup): HotDoc {
        const colFactory = () => this.buildColumnDefinitions({ readOnly: !this.canEdit,
            type: "numeric" });
        const rowFactory = (doc: HotDoc) => this.buildRowDefinitions(
            doc,
            {
                cellFactory: (pmData) => new BegransningCell(pmData, form, Cellstyle.Default | Cellstyle.AlignCenter),
                columnSummaryFactory: (cells) => new EmptyCell(),
                rowSummaryFactory: (cells) => new EmptyCell(),
                sumOfSumsFactory: (cells) => new EmptyCell()
            }, raskModalService, this.showVardematrisPrisrad);
        const settingsFactory = (doc: HotDoc) => this.getBaseSettings(doc, raskModalService, {
            outsideClickDeselects: this.outsideClickDeselector
        });

        return new HotDoc(colFactory, rowFactory, settingsFactory);
    }

    setKapkriteria(hotDoc: HotDoc, kapkriteria: string, cells: any[]) {
        const produktmatriser = this.getCellsOfType(cells, hotDoc, BegransningCell);
        produktmatriser.forEach((cell) => {
            if (cell.prismatris.kapkriteria !== kapkriteria) {
                cell.prismatris.kapkriteria = kapkriteria;
                cell.prismatris.markAsDirty();
                cell.value = BegransningCell.fromKapkriterie(kapkriteria);
                this.form.markAsDirty();
            }
        });

        hotDoc.rebind();
    }
}
